module.exports = __webpack_public_path__ + "img/competition-960x327.6572a283.jpg";